var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import Loading from "../../../../components/shared/loading";
import AddWidgetModal from "../../../../components/dashboard/addWidgetModal";
import DashboardLayoutModalComponent from "../../Containers/DashboardLayoutModalComponent";
import { widgetIds } from "../../../Domain/Dashboard/Widget.model";
import DashboardService from "../../../../services/DashboardService";
import DashboardServiceNew from "../../../Services/Dashboard.service";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import FAIcon from "../../UI/FAIcon/FAIcon";
import { advisorHomeLink } from "../Advisor/AdvisorRoutes";
import ErrorService from "../../../Services/Shared/Error.service";
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};
export default class DashboardEdit extends PureComponent {
    constructor(props) {
        super(props);
        this.getNextNewId = () => {
            // @ts-expect-error - TS2339 - Property 'nextNewId' does not exist on type 'DashboardEdit'.
            const newId = this.nextNewId;
            // @ts-expect-error - TS2339 - Property 'nextNewId' does not exist on type 'DashboardEdit'.
            this.nextNewId -= 1;
            return newId;
        };
        this.onTitleChanged = (event) => {
            const changedTitle = event.target.value;
            // @ts-expect-error - TS2345 - Argument of type '(s: Readonly<State>) => { dashboard: { title: any; id?: number | undefined; dashboardLayout?: DashboardLayout | undefined; }; hasUnsavedChanges: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "dashboard" | "hasUnsavedChanges"> | null) | Pick<...> | null'.
            this.setState((s) => ({
                dashboard: Object.assign(Object.assign({}, s.dashboard), { title: changedTitle }),
                hasUnsavedChanges: true,
            }));
            this.validateForm();
        };
        this.validateForm = () => {
            let isValid = true;
            if (
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            !this.state.dashboard.title ||
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                this.state.dashboard.title.trim() === "") {
                isValid = false;
                this.setState({ isTitleValid: false });
            }
            else {
                this.setState({ isTitleValid: true });
            }
            return isValid;
        };
        this.onSaveClick = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.validateForm()) {
                return;
            }
            try {
                this.setState({
                    hasError: false,
                    errorMessage: null,
                    isSaving: true,
                    showSaveSuccess: false,
                });
                // Collect all the dashboard widgets into a flat array.
                const dashboardWidgets = this.state.widgetsGrouped
                    .map((wg) => wg.value)
                    .reduce((previousValue, currentValue, currentIndex, array) => [
                    ...previousValue,
                    ...currentValue,
                ], []);
                const response = yield DashboardService.save(
                // @ts-expect-error - TS2345 - Argument of type 'Dashboard | null | undefined' is not assignable to parameter of type 'Dashboard'.
                this.state.dashboard, dashboardWidgets);
                if (response.success) {
                    this.setState({
                        showSaveSuccess: true,
                        hasUnsavedChanges: false,
                    });
                }
                else {
                    this.setState({
                        hasError: true,
                        errorMessage: response.message,
                    });
                }
            }
            catch (e) {
                const errMessage = ErrorService.getMessageFromError(e);
                this.setState({
                    hasError: true,
                    errorMessage: errMessage,
                });
            }
            finally {
                this.setState({ isSaving: false });
            }
        });
        this.onAddWidgetsClick = (section) => {
            this.loadWidgets();
            this.setState({
                addingWidgetsToSection: section,
                addWidgetModalOpen: true,
            });
        };
        this.loadWidgets = () => __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoadingWidgets: true, loadingWidgetsError: null });
                const widgets = yield DashboardService.fetchWidgets(this.state.dashboardId);
                widgets.sort((a, b) => {
                    if (a.title.toUpperCase() < b.title.toUpperCase()) {
                        return -1;
                    }
                    return 1;
                });
                this.setState({ widgets, widgetsLoaded: true });
                // fetch reports
                const filters = yield DashboardService.fetchFiltersForDashboard({
                    id: this.state.dashboardId,
                }, {
                    max: 20,
                    offset: this.state.filterOffset,
                });
                this.setState({
                    filters: filters.data,
                    filterHasNext: filters.maxResults + filters.offset < filters.total,
                    filtersLoaded: true,
                    filterOffset: filters.offset,
                });
            }
            catch (e) {
                this.setState({
                    loadingWidgetsError: ErrorService.getMessageFromError(e),
                });
            }
            finally {
                this.setState({ isLoadingWidgets: false });
            }
        });
        this.onAddWidgetModalSave = (widgets, filters) => {
            if ((!widgets || !widgets.length) && (!filters || !filters.length)) {
                return;
            }
            // duplicate the existing array of widget groups
            const newWidgetGroups = [...this.state.widgetsGrouped];
            // find the group (section) we are adding the widgets to
            let addingToGroup = newWidgetGroups.find((wg) => wg.key === this.state.addingWidgetsToSection);
            // if we didn't find the group we are adding to, then we're adding to an empty group,
            // so we create a new group.
            if (!addingToGroup) {
                addingToGroup = {
                    // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number'.
                    key: this.state.addingWidgetsToSection,
                    value: [],
                };
                // @ts-expect-error - TS2345 - Argument of type 'DashboardWidgetGroup | undefined' is not assignable to parameter of type 'DashboardWidgetGroup'.
                newWidgetGroups.push(addingToGroup);
            }
            // add the selected widgets to the appropriate group (section).
            if (addingToGroup) {
                const newWidgetList = [...addingToGroup.value];
                // @ts-expect-error - TS2322 - Type '{ id: any; section: number | null | undefined; widget: Widget; sortOrder: number; }[]' is not assignable to type 'DashboardWidget[]'.
                const newDashboardWidgets = widgets.map((w, index) => ({
                    id: this.getNextNewId(),
                    section: this.state.addingWidgetsToSection,
                    widget: w,
                    sortOrder: index + newWidgetList.length,
                }));
                // A dashboard widget that represents a report is a dashboardwidget that relates to the "report" widget, and has
                // a dashboard widget param associated with it that contains the ID of the report.
                // @ts-expect-error - TS2741 - Property 'description' is missing in type '{ id: 16; title: string; }' but required in type 'Widget'.
                const reportWidget = { id: widgetIds.report, title: "Report" };
                // @ts-expect-error - TS2322 - Type '{ id: any; section: number | null | undefined; widget: Widget; sortOrder: number; dashboardWidgetParams: { key: string; value: number; }[]; title: string; }[]' is not assignable to type 'DashboardWidget[]'.
                const newFilterWidgets = filters.map((f, index) => ({
                    id: this.getNextNewId(),
                    section: this.state.addingWidgetsToSection,
                    widget: reportWidget,
                    sortOrder: index + newWidgetList.length,
                    dashboardWidgetParams: [{ key: "reportId", value: f.id }],
                    title: f.name,
                }));
                addingToGroup.value = [
                    ...newWidgetList,
                    ...newDashboardWidgets,
                    ...newFilterWidgets,
                ];
                this.setState({
                    widgetsGrouped: newWidgetGroups,
                    hasUnsavedChanges: true,
                });
            }
        };
        this.onDragEnd = (result) => {
            const { source, destination } = result;
            // Dropped outside of list.
            if (!destination) {
                return;
            }
            const newWidgetGroups = [...this.state.widgetsGrouped];
            if (source.droppableId === destination.droppableId) {
                const widgetGroup = newWidgetGroups.find((g) => g.key.toString() === source.droppableId);
                if (!widgetGroup) {
                    return;
                }
                const widgets = widgetGroup.value;
                const reorderedWidgets = reorder(widgets, source.index, destination.index);
                widgetGroup.value = reorderedWidgets;
            }
            else {
                let sourceWidgetGroup = newWidgetGroups.find((g) => g.key.toString() === source.droppableId);
                let destWidgetGroup = newWidgetGroups.find((g) => g.key.toString() === destination.droppableId);
                if (!sourceWidgetGroup) {
                    sourceWidgetGroup = {
                        key: parseInt(source.droppableId, 10),
                        value: [],
                    };
                    // @ts-expect-error - TS2349 - This expression is not callable.
                    newWidgetGroups(sourceWidgetGroup);
                }
                if (!destWidgetGroup) {
                    destWidgetGroup = {
                        key: parseInt(destination.droppableId, 10),
                        value: [],
                    };
                    this.setState((s) => ({
                        // @ts-expect-error - TS2769 - No overload matches this call.
                        widgetsGrouped: s.widgetsGrouped.concat([destWidgetGroup]),
                    }));
                }
                const sourceWidgets = sourceWidgetGroup.value;
                const destWidgets = destWidgetGroup.value;
                const moveResult = move(sourceWidgets, destWidgets, source, destination);
                sourceWidgetGroup.value = moveResult[source.droppableId];
                destWidgetGroup.value = moveResult[destination.droppableId];
            }
            // Make sure the section and sort order are correct after the reordering/moving.
            this.setState((s) => {
                return {
                    widgetsGrouped: s.widgetsGrouped.map((widgetGroup) => (Object.assign(Object.assign({}, widgetGroup), { value: widgetGroup.value.map((val, index) => (Object.assign(Object.assign({}, val), { section: widgetGroup.key, sortOrder: index }))) }))),
                    hasUnsavedChanges: true,
                };
            });
        };
        this.onReportWidgetDeliveryChange = (dashboardWidget, delivery) => {
            this.state.widgetsGrouped.forEach((widgetGroup) => {
                widgetGroup.value.forEach((widget) => {
                    if (dashboardWidget === widget) {
                        let reportDisplayParam = widget.dashboardWidgetParams &&
                            widget.dashboardWidgetParams.find((dwp) => dwp.key === "reportDisplay");
                        if (!reportDisplayParam) {
                            reportDisplayParam = {
                                id: -1,
                                key: "reportDisplay",
                                value: "",
                            };
                        }
                        reportDisplayParam.value = delivery;
                        if (widget.dashboardWidgetParams) {
                            widget.dashboardWidgetParams = [
                                ...widget.dashboardWidgetParams,
                                reportDisplayParam,
                            ];
                        }
                        else {
                            widget.dashboardWidgetParams = [reportDisplayParam];
                        }
                    }
                });
            });
            this.setState({ widgetsGrouped: [...this.state.widgetsGrouped] });
        };
        this.renderHeaderArea = () => (_jsxs("div", { children: [_jsx("div", { className: "title-block clearfix", children: _jsxs("h1", { className: "title float-left", children: [_jsxs(Link, { to: advisorHomeLink({}), className: "text-decoration-none", title: "Back to Dashboard", children: [_jsx("span", { className: "fal fa-arrow-circle-left", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Back to Dashboard" })] }), " ", "Edit Dashboard"] }) }), this.state.showSaveSuccess && (_jsxs("div", { className: "alert alert-success", children: [_jsx("span", { className: "fa fa-check-circle" }), " Dashboard saved!"] })), this.state.hasError && (_jsx("div", { className: "alert alert-danger", children: _jsxs("div", { children: [_jsx("span", { className: "fa fa-exclamation-circle" }), " ", _jsx("span", { children: this.state.errorMessage })] }) })), _jsx(Loading, { isLoading: this.state.isLoadingDashboardEdit })] }));
        this.state = {
            addingWidgetsToSection: null,
            addWidgetModalOpen: false,
            dashboardId: props.match.params.id,
            dashboard: null,
            hasError: false,
            hasUnsavedChanges: false,
            errorMessage: null,
            showSaveSuccess: false,
            widgetsGrouped: [],
            removedWidgets: [],
            isLoadingWidgets: false,
            isSaving: false,
            isTitleValid: true,
            widgets: [],
            widgetsLoaded: false,
            filters: [],
            filtersLoaded: false,
            loadingWidgetsError: null,
            isLoadingDashboardEdit: false,
            isDashboardLayoutModalOpen: false,
            widgetPage: 0,
            filterPage: 0,
            filterHasNext: false,
            filterOffset: 0,
            dashboardLayouts: null,
        };
        // @ts-expect-error - TS2339 - Property 'nextNewId' does not exist on type 'DashboardEdit'.
        this.nextNewId = -1;
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        this.fetchData();
    }
    componentDidMount() {
        window.onbeforeunload = () => {
            if (this.state.hasUnsavedChanges) {
                return "You have unsaved changes. Are you sure you want to leave?";
            }
            return null;
        };
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isLoadingDashboardEdit: true });
            try {
                const data = yield DashboardService.fetchDashboardAndWidgets(this.state.dashboardId);
                // @ts-expect-error - TS2339 - Property 'success' does not exist on type 'DashboardAndWidgets'. | TS2339 - Property 'success' does not exist on type 'DashboardAndWidgets'.
                if (data.success === null || data.success === false) {
                    this.setState({
                        hasError: true,
                        errorMessage: data.message,
                        isLoadingDashboardEdit: false,
                    });
                }
                else {
                    this.setState({
                        dashboard: data.dashboard,
                        widgetsGrouped: data.widgetsGrouped,
                        isLoadingDashboardEdit: false,
                    });
                }
                const layouts = yield DashboardServiceNew.getDashboardLayouts();
                this.setState({ dashboardLayouts: layouts });
                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                this.resetWidgetGroups(this.state.dashboard.dashboardLayout);
            }
            catch (e) {
                this.setState({
                    hasError: true,
                    errorMessage: `There was a problem loading the dashboard.\n${e}`,
                    isLoadingDashboardEdit: false,
                });
            }
        });
    }
    removeWidget(dashboardWidget) {
        this.setState((s) => ({
            widgetsGrouped: s.widgetsGrouped.map((wg) => (Object.assign(Object.assign({}, wg), { value: wg.value.filter((val, i) => wg.value.indexOf(dashboardWidget) !== i) }))),
            removedWidgets: [...s.removedWidgets, dashboardWidget],
            hasUnsavedChanges: true,
        }));
    }
    //------
    getSelectedWidgets() {
        // Collect a list of the selected widgets' ids.
        const selectedWidgetIds = this.state.widgetsGrouped
            .map((wg) => wg.value)
            .reduce((previousValue, currentValue) => [...previousValue, ...currentValue], [])
            .filter((uw) => {
            return uw != null;
        })
            .map((w) => w.widget.id);
        // translate ids to selected widgets
        const selectedWidgets = this.state.widgets.filter((w) => selectedWidgetIds.includes(w.id));
        return selectedWidgets;
    }
    //-----
    getSelectedFilterWidgets() {
        // Filtering out on dashboardWidgetParams.length will find all report widgets
        // They are then mapped by getting the report value from that object.
        const selectedFilterWidgetIds = this.state.widgetsGrouped
            .map((wg) => wg.value)
            .reduce((previousValue, currentValue) => [...previousValue, ...currentValue], [])
            .filter((uw) => {
            return uw != null;
        })
            .filter((w) => { var _a; return (_a = w.dashboardWidgetParams) === null || _a === void 0 ? void 0 : _a.length; })
            .map((w) => parseInt(
        // @ts-expect-error - TS7006 - Parameter 'param' implicitly has an 'any' type.
        w.dashboardWidgetParams.find((param) => param.key === "reportId")
            .value, 10));
        return this.state.filters.filter((w) => selectedFilterWidgetIds.includes(w.id));
    }
    /*
    Sets the number of widget groups to the total number of draggable areas by concatenating all the groups with a key larger
    than the total number of draggable areas into the last group
     */
    resetWidgetGroups(selectedLayout) {
        const lastSection = selectedLayout.dashboardLayoutSections.length;
        const outOfBoundsWidgetGroups = this.state.widgetsGrouped
            .filter((wg) => wg.key >= lastSection)
            .map((wg) => {
            return wg.value;
        })
            .flat();
        this.setState((s) => {
            return {
                widgetsGrouped: [
                    ...s.widgetsGrouped
                        .filter((uw) => uw != null)
                        .filter((wg) => wg.key < lastSection),
                ].concat([
                    {
                        key: lastSection,
                        value: outOfBoundsWidgetGroups.map((val, index) => (Object.assign(Object.assign({}, val), { section: lastSection, sortOrder: index }))),
                    },
                ]),
            };
        });
    }
    onLayoutChange(selectedLayout) {
        if (selectedLayout) {
            this.resetWidgetGroups(selectedLayout);
            // @ts-expect-error - TS2345 - Argument of type '(s: Readonly<State>) => { dashboard: { dashboardLayout: DashboardLayout; id?: number | undefined; title?: string | undefined; }; hasUnsavedChanges: true; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, "dashboard" | "hasUnsavedChanges"> | null) | Pick<...> | null'.
            this.setState((s) => {
                return {
                    dashboard: Object.assign(Object.assign({}, s.dashboard), { dashboardLayout: selectedLayout }),
                    hasUnsavedChanges: true,
                };
            });
        }
        else {
            // Make sure the section and sort order are correct after the reordering/moving.
            this.setState((s) => {
                return {
                    hasUnsavedChanges: true,
                    widgetsGrouped: s.widgetsGrouped.map((widgetGroup) => (Object.assign(Object.assign({}, widgetGroup), { value: widgetGroup.value.map((val, index) => (Object.assign(Object.assign({}, val), { section: widgetGroup.key, sortOrder: index }))) }))),
                };
            });
        }
    }
    onChangeLayoutClick() {
        this.setState({ isDashboardLayoutModalOpen: true });
    }
    renderDashboardForm() {
        if (!this.state.dashboard) {
            return _jsx("div", {});
        }
        return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: "dashboard-title", className: "control-label font-weight-bold", children: "Title" }), _jsxs("div", { children: [_jsx("input", { className: `form-control ${!this.state.isTitleValid ? " is-invalid" : ""}`, onChange: this.onTitleChanged, required: true, type: "text", value: this.state.dashboard.title, style: { maxWidth: 600 }, id: "dashboard-title" }), _jsx("div", { className: "invalid-feedback", children: "Title is required" })] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { className: "control-label font-weight-bold", children: "Layout" }), _jsxs("div", { className: "d-flex align-items-center", children: [_jsx("span", { children: this.state.dashboard.dashboardLayout.title }), _jsxs("button", { type: "button", className: "btn btn-link", onClick: () => {
                                        this.onChangeLayoutClick();
                                    }, children: [_jsx(FAIcon, { icon: "pencil", addMarginRight: true }), _jsx("span", { className: "sr-only", children: "Change" })] })] })] })] }));
    }
    renderWidgetsForSection(section, andGreater, provided, snapshot) {
        if (!this.state.widgetsGrouped || !this.state.widgetsGrouped.length) {
            return _jsx("div", {});
        }
        const widgetGroups = this.state.widgetsGrouped.filter((g) => {
            if (andGreater) {
                return g.key >= section;
            }
            return g.key === section;
        });
        if (!widgetGroups) {
            return _jsx("div", {});
        }
        return (widgetGroups
            .flatMap((w) => w.value)
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 4.
            .map((w, index) => this.renderWidget(w, index, provided, snapshot)));
    }
    renderWidget(dashboardWidget, index) {
        if (!dashboardWidget) {
            return null;
        }
        let widgetTitle = dashboardWidget.widget.title;
        let isReport = false;
        let delivery = "grid";
        if (dashboardWidget.widget.id === widgetIds.report) {
            // we need the title of the report itself to display this correctly. This is stored in a title property
            // on the dashboardwidget object.
            isReport = true;
            widgetTitle = dashboardWidget.title;
            // See if the delivery is set to grid or chart
            const deliveryParam = dashboardWidget.dashboardWidgetParams &&
                dashboardWidget.dashboardWidgetParams.find((dwp) => dwp.key === "reportDisplay");
            if (deliveryParam) {
                delivery = deliveryParam.value;
            }
        }
        return (_jsx(Draggable, { draggableId: dashboardWidget.id.toString(), index: index, children: (provided) => (_jsxs("div", Object.assign({ className: "border rounded p-3 mt-3 bg-white d-flex justify-content-between", ref: provided.innerRef }, provided.draggableProps, { children: [_jsx("div", Object.assign({}, provided.dragHandleProps, { className: "flex-grow-1 d-flex", children: widgetTitle })), _jsxs("div", { children: [isReport && (_jsxs("div", { className: "btn-group btn-group-sm mr-3", role: "group", children: [_jsx("button", { onClick: () => {
                                            this.onReportWidgetDeliveryChange(dashboardWidget, "grid");
                                        }, className: `btn ${delivery === "grid"
                                            ? "btn-primary"
                                            : "btn-outline-secondary"}`, children: "Grid" }), _jsx("button", { onClick: () => {
                                            this.onReportWidgetDeliveryChange(dashboardWidget, "chart");
                                        }, className: `btn ${delivery === "chart"
                                            ? "btn-primary"
                                            : "btn-outline-secondary"}`, children: "Chart" })] })), _jsxs("button", { className: "btn btn-sm btn-outline-danger", onClick: () => this.removeWidget(dashboardWidget), title: "Remove widget", type: "button", children: [_jsx("span", { className: "fa fa-trash", "aria-hidden": "true" }), _jsxs("span", { className: "sr-only", children: ["Delete ", widgetTitle] })] })] })] }))) }, dashboardWidget.id));
    }
    renderSection(section, isLastSection, provided, snapshot) {
        return (_jsxs("div", { className: "card card-body bg-light", children: [_jsx("div", { children: _jsxs("button", { className: "btn btn-outline-secondary", onClick: () => this.onAddWidgetsClick(section), type: "button", title: "Add Content to Dashboard", children: [_jsx(FAIcon, { icon: "plus", addMarginRight: true }), _jsx("span", { children: "Add Content" })] }) }), this.renderWidgetsForSection(section, isLastSection, provided, snapshot), provided.placeholder] }));
    }
    render() {
        return (_jsx(SecondaryNavLayout, { nav: _jsx("div", { className: "d-flex w-100", children: _jsx(SecondaryNavButton, { onClick: this.onSaveClick, label: "Save", disabled: this.state.isSaving, title: "Save Dashboard", icon: "save", iconType: "fas" }) }), children: _jsx("div", { className: "fullMinHeightMinusPrimaryNav", children: _jsxs("div", { className: "container-fluid py-3", children: [this.renderHeaderArea(), this.renderDashboardForm(), _jsx("h2", { children: "Widgets and Layout" }), _jsx(DragDropContext, { onDragEnd: this.onDragEnd, children: _jsx("div", { className: "row", children: this.state.dashboard &&
                                    this.state.dashboard.dashboardLayout.dashboardLayoutSections.map((dls, index) => (_jsx(Droppable, { droppableId: dls.sectionOrder.toString(), direction: "vertical", ignoreContainerClipping: false, isDropDisabled: false, type: "DEFAULT", children: (provided, snapshot) => (_jsx("div", { className: `col-${dls.width} mb-3`, ref: provided.innerRef, children: this.renderSection(dls.sectionOrder, index ===
                                                // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                                                this.state.dashboard.dashboardLayout
                                                    .dashboardLayoutSections.length -
                                                    1, provided, snapshot) })) }, dls.sectionOrder))) }) }), _jsx(AddWidgetModal, { isOpen: this.state.addWidgetModalOpen, onModalClosed: () => {
                                this.setState({ addWidgetModalOpen: false });
                            }, isLoading: this.state.isLoadingWidgets, modalId: "addWidgetModal", onSave: this.onAddWidgetModalSave, widgets: this.state.widgets, addedWidgets: this.getSelectedWidgets(), filters: this.state.filters, errorMessage: this.state.loadingWidgetsError, filterHasNext: this.state.filterHasNext, addedFilters: this.getSelectedFilterWidgets(), setFilterOffset: (offset) => {
                                this.setState({ filterOffset: offset });
                                this.loadWidgets();
                            }, filterOffset: this.state.filterOffset }), _jsx(DashboardLayoutModalComponent, { isOpen: this.state.isDashboardLayoutModalOpen, onModalClosed: () => {
                                this.setState({ isDashboardLayoutModalOpen: false });
                            }, dashboardLayouts: this.state.dashboardLayouts, 
                            // @ts-expect-error - TS2322 - Type 'DashboardLayout | null | undefined' is not assignable to type 'DashboardLayout'.
                            selectedDashboardLayout: this.state.dashboard && this.state.dashboard.dashboardLayout, onLayoutChange: (newLayout) => {
                                this.onLayoutChange(newLayout);
                            } })] }) }) }));
    }
}
